// membership/get-customer-details
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const MembershipListss = () => {
  
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [packageList, setPackageList] = useState([]);
   const [showModal, setShowModal] = useState(false);
   const [selectedServices, setSelectedServices] = useState([]);


  useEffect(() => {
    fetchbookinghistory();
}, [currentPage]);

const fetchbookinghistory = async () => {
  const token = localStorage.getItem('token');
//   const userId = localStorage.getItem('userIdd');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/membership/get-customer-details`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setPackageList(response.data);
      setIsLogin(false);
  } catch (error) {
    setPackageList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter employees before applying pagination
  const filteredPackages = packageList.filter((pack) => {
    const searchLower = searchQuery.toLowerCase();
    console.log(pack.customer_details.name);
    return (
      (pack.membership_no && pack.membership_no.toLowerCase().includes(searchLower)) ||
      (pack.customer_details?.name &&
        pack.customer_details.name.toLowerCase().includes(searchLower)) ||
      (pack.customer_details?.email_id &&
        pack.customer_details.email_id.toLowerCase().includes(searchLower)) ||
      (pack.customer_details?.mobile_no &&
        pack.customer_details.mobile_no.toLowerCase().includes(searchLower))
    );
  });
  
  
  // Apply pagination to the filtered list
  const paginatedFilteredPackages = filteredPackages.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };
  const handleShowModal = (services) => {
    setSelectedServices(services);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedServices([]);
  };

    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       MEMBERSHIP LIST
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none",padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                <div className="row align-items-center" style={{ margin: "0", padding: "0" }}>
    <div className="col-12 d-flex justify-content-between align-items-center" style={{ marginBottom: "5px" }}>
        
        {/* <button className="btn btn-primary" style={{ marginRight: "10px" }}>
            Buy Membership
        </button> */}
        <Form.Control
            type="text"
            placeholder="Search..."
            className="form-control"
            onChange={handleSearchInput}
            style={{ maxWidth: "300px" }}
        />
    </div>
</div>

                
                <Table className="table align-middle table-nowrap mb-0">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Email ID</th>
                <th>Mobile No</th>
                <th>Address Location</th>
                <th>Membership No</th>
                <th>Show Services</th>
              </tr>
            </thead>
            <tbody>
              {paginatedFilteredPackages.length > 0 ? (
                paginatedFilteredPackages.map((data, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{data.customer_details?.name || "-"}</td>
                  <td>{data.customer_details?.email_id || "-"}</td>
                  <td>{data.customer_details?.mobile_no || "-"}</td>
                  <td>{data.customer_details?.address_location || "-"}</td>
                  <td>{data.membership_no}</td>
                  <td>
                    <Button
                      variant="dark"
                      onClick={() => handleShowModal(data.services)}
                    >
                      {data.services.length} {data.services.length > 1 ? 'Services' : 'Service'}
                    </Button>
                  </td>
                </tr>
              )))
               : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredPackages.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
            <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Services</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Search Input */}
          {/* <div className="d-flex justify-content-end mt-4">
            <div className="search-box">
              <input
                type="text"
                className="form-control search"
                placeholder="Search"
                // Add search logic here
              />
            </div>
          </div> */}

          {/* Services Table */}
          <div className="table-responsive mt-3">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Service Name</th>
                  <th>Service Price</th>
                  <th>Service Duration</th>
                  <th>Description</th>
                  <th>Actual Amount</th>
                  <th>Balance Amount</th>
                  <th>Paid Amount</th>
                  <th>Used Amount</th>
                  <th>Transaction ID</th>
                  <th>Paid Date</th>
                </tr>
              </thead>
              <tbody>
                {selectedServices.length > 0 ? (
                  selectedServices.map((service, index) => (
                    <tr key={index}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{service.service_name ? service.service_name : '-'}</td>
                      <td>{service.service_price ? service.service_price : '-'}</td>
                      <td>{service.service_duration ? service.service_duration : '-'}</td>
                      <td>{service.description ? service.description : '-'}</td>
                      <td>{service.actual_amount ? service.actual_amount : '-'}</td>
                      <td>{service.balance_amount ? service.balance_amount : '-'}</td>
                      <td>{service.paid_amount ? service.paid_amount : '-'}</td>
                      <td>{service.used_amount ? service.used_amount : '-'}</td>
                      <td>{service.transaction_id ? service.transaction_id : '-'}</td>
                      <td>{service.paid_date ? service.paid_date : '-'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No services available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
        </div>
        </>
    )
}

export default MembershipListss;